/** 24-hour clock in the company's own time zone, so what a dispatcher reads and pastes is the time on the wall where the company is. */
export function clockText(iso: string, timezone: string): string {
  return new Intl.DateTimeFormat('en-GB', { timeZone: timezone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(iso));
}

export function dayText(iso: string, timezone: string): string {
  return new Intl.DateTimeFormat('en-GB', { timeZone: timezone, day: 'numeric', month: 'short' }).format(new Date(iso));
}

/** The time, with its day in front when it is not on `referenceIso`'s day, so a run over midnight does not read as two clocks. */
export function clockWithDay(iso: string, referenceIso: string, timezone: string): string {
  const clock = clockText(iso, timezone);
  return dayText(iso, timezone) === dayText(referenceIso, timezone) ? clock : `${dayText(iso, timezone)} ${clock}`;
}
